import JhaGate from '../components/clock/JhaGate.jsx';
import ClockWidget from '../components/clock/ClockWidget.jsx';
import CrewRosterPanel from '../components/clock/CrewRosterPanel.jsx';
import { useAuth } from '../hooks/useAuth.js';

export default function ClockPage() {
  const { isAdminSurface } = useAuth();
  return (
    <>
      <JhaGate />
      <ClockWidget />
      {isAdminSurface && <CrewRosterPanel />}
    </>
  );
}
